import {
  LIST_BRANCH_REQUEST,
  LIST_BRANCH_SUCCESS,
  LIST_BRANCH_FAIL,
  LIST_BRANCH_SUMMARY_REQUEST,
  LIST_BRANCH_SUMMARY_SUCCESS,
  LIST_BRANCH_SUMMARY_FAIL,
  CREATE_BRANCH_REQUEST,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_FAIL,
  UPDATE_BRANCH_REQUEST,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_FAIL,
  DETAIL_BRANCH_REQUEST,
  DETAIL_BRANCH_SUCCESS,
  DETAIL_BRANCH_FAIL,
  DELETE_BRANCH_REQUEST,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAIL,
  BRANCH_RESET,
  BRANCH_LIST_WORKING_DAY_REQUEST,
  BRANCH_LIST_WORKING_DAY_SUCCESS,
  BRANCH_LIST_WORKING_DAY_FAIL,
  CREATE_BRANCH_WORKING_HOUR_REQUEST,
  CREATE_BRANCH_WORKING_HOUR_SUCCESS,
  CREATE_BRANCH_WORKING_HOUR_FAIL,
  DETAIL_BRANCH_WORKING_HOUR_REQUEST,
  DETAIL_BRANCH_WORKING_HOUR_SUCCESS,
  DETAIL_BRANCH_WORKING_HOUR_FAIL,
  UPDATE_BRANCH_WORKING_HOUR_REQUEST,
  UPDATE_BRANCH_WORKING_HOUR_SUCCESS,
  UPDATE_BRANCH_WORKING_HOUR_FAIL,
  DELETE_BRANCH_WORKING_HOUR_REQUEST,
  DELETE_BRANCH_WORKING_HOUR_SUCCESS,
  DELETE_BRANCH_WORKING_HOUR_FAIL,
  UPDATE_BRANCH_KIT_REQUEST,
  UPDATE_BRANCH_KIT_SUCCESS,
  UPDATE_BRANCH_KIT_FAIL,
  GET_BRANCH_KIT_REQUEST,
  GET_BRANCH_KIT_SUCCESS,
  GET_BRANCH_KIT_FAIL
} from '../../constants/branches'

const initialState = {
  branches: [],
  branchSummaries: [],
  branch: {},
  pageable: {},
  kitActive: {},
  branchWorkingDays: [],
  practitionerSummary: [],
  loading: false,
  loadingUpdate: false,
  loadingDetail: false,
  error: ''
}

const branchesReducer = (state = initialState, action) => {
  switch (action.type) {
    //** branches */
    case LIST_BRANCH_REQUEST:
      return { ...state, loading: true }
    case LIST_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        branches: action.payload,
        pageable: action.pageable
      }
    case LIST_BRANCH_FAIL:
      return { ...state, loading: false, error: action.payload, branches: [] }
    case LIST_BRANCH_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_BRANCH_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        branchSummaries: action.payload,
        filterByUserLogin: action.filterByUserLogin
      }
    case LIST_BRANCH_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case BRANCH_RESET:
      return { branches: [] }
    case CREATE_BRANCH_REQUEST:
      return { ...state, loading: true }
    case CREATE_BRANCH_SUCCESS:
      const newBranch = action.payload
      return {
        loading: false,
        branches: [...state.branches, newBranch],
        pageable: action.pageable
      }
    case CREATE_BRANCH_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DETAIL_BRANCH_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_BRANCH_SUCCESS:
      return { ...state, loadingDetail: false, branch: action.payload }
    case DETAIL_BRANCH_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case GET_BRANCH_KIT_REQUEST:
      return { ...state, loadingDetail: true }
    case GET_BRANCH_KIT_SUCCESS:
      return { ...state, loadingDetail: false, kitActive: action.payload }
    case GET_BRANCH_KIT_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_BRANCH_REQUEST:
      return { ...state, loading: true }
    case UPDATE_BRANCH_SUCCESS:
      const branchesData = [...state?.branches]
      const index = branchesData.findIndex(
        (branch) => branch.id === action.payload.id
      )
      branchesData[index] = action.payload
      return {
        ...state,
        loading: false,
        branches: branchesData,
        pageable: action.pageable
      }
    case UPDATE_BRANCH_KIT_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case UPDATE_BRANCH_KIT_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_BRANCH_KIT_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_BRANCH_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DELETE_BRANCH_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DELETE_BRANCH_SUCCESS:
      const newDeleteBranch = action.payload
      const newDataDeleteBranch = [...state.branches]
      const indexDeleteBranch = newDataDeleteBranch.findIndex(
        (branch) => branch.id === newDeleteBranch
      )
      newDataDeleteBranch.splice(indexDeleteBranch, 1)

      return {
        ...state,
        loading: false,
        branches: newDataDeleteBranch
      }
    case DELETE_BRANCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    //** End  */

    //** Branch Working Days & Hours */
    case BRANCH_LIST_WORKING_DAY_REQUEST:
      return { ...state, loading: true }
    case BRANCH_LIST_WORKING_DAY_SUCCESS:
      return { ...state, loading: false, branchWorkingDays: action.payload }
    case BRANCH_LIST_WORKING_DAY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_BRANCH_WORKING_HOUR_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_BRANCH_WORKING_HOUR_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_BRANCH_WORKING_HOUR_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_BRANCH_WORKING_HOUR_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_BRANCH_WORKING_HOUR_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        branchWorkingDay: action.payload
      }
    case DETAIL_BRANCH_WORKING_HOUR_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_BRANCH_WORKING_HOUR_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_BRANCH_WORKING_HOUR_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_BRANCH_WORKING_HOUR_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_BRANCH_WORKING_HOUR_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_BRANCH_WORKING_HOUR_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_BRANCH_WORKING_HOUR_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case "SUB_CATEGORY_SUMMARY_REQUEST":
      return { ...state, loading: true }
    case "SUB_CATEGORY_SUMMARY_SUCCESS":
      return {
        ...state,
        loading: false,
        subCategorySummaries: action.payload
      }
    case "SUB_CATEGORY_SUMMARY_FAIL":
      return { ...state, loading: false, error: action.payload }
    //** End  */
    case "BRANCH_PRACTITIONER_SUMMARY_REQUEST":
      return { ...state, loading: true, practitionerSummary: [] }
    case "BRANCH_PRACTITIONER_SUMMARY_SUCCESS":
      return {
        ...state,
        loading: false,
        practitionerSummary: action.payload
      }
    case "BRANCH_PRACTITIONER_SUMMARY_FAIL":
      return { ...state, loading: false, error: action.payload, practitionerSummary: [] }
    default:
      return state
  }
}

export default branchesReducer
